import { useEffect, useState } from 'react'
import { getClient } from '../client'
import { detectLang } from '../types'
import type { SanityImageSource } from '@sanity/image-url'

export type NewsArticleSummary = {
  _id: string
  title?: string
  slug?: { current: string }
  image?: SanityImageSource
  publishedAt?: string
}

const QUERY = `*[_type == "newsArticle" && language == $lang] | order(publishedAt desc) {
  _id, title, slug, image, publishedAt
}`

export function useNewsArticles() {
  const [articles, setArticles] = useState<NewsArticleSummary[]>([])
  const lang = detectLang()

  useEffect(() => {
    getClient().fetch<NewsArticleSummary[]>(QUERY, { lang }).then(setArticles)
  }, [lang])

  return articles
}
